import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Text } from "native-base";
import { boxShadow, tag, tagThreshold, tagYaxis } from "./useStyles";
export default function Tags({ graphData = {} }) {
    const { randomIdFragment = "", coords = [], limits, paddings = { x: 0, y: 0 }, thresholds = [], slot, } = graphData;
    const yMax = limits === null || limits === void 0 ? void 0 : limits.yMax;
    const yMin = limits === null || limits === void 0 ? void 0 : limits.yMin;
    const yMaxTitle = limits === null || limits === void 0 ? void 0 : limits.yMaxTitle;
    const yMinTitle = limits === null || limits === void 0 ? void 0 : limits.yMinTitle;
    const minWidthThreshold = Math.max(0, ...thresholds.map(({ title }) => Number(title === null || title === void 0 ? void 0 : title.length))) *
        7;
    const transformStyle = [{ translateX: -3 }, { translateY: 10 }];
    return coords.length ? (_jsxs(_Fragment, { children: [thresholds.length ? (thresholds.map(({ limit, title = "" }, i) => {
                var _a;
                return (_jsx(Fragment, { children: !!title.length &&
                        limit &&
                        slot &&
                        limit < ((_a = slot === null || slot === void 0 ? void 0 : slot.y) !== null && _a !== void 0 ? _a : yMax) ? (_jsx(Text, Object.assign({ style: [
                            boxShadow,
                            tag,
                            tagThreshold,
                            {
                                bottom: limit,
                                left: coords[0].x,
                                transform: [
                                    { translateX: 0 },
                                    { translateY: 10 },
                                ],
                            },
                        ], minWidth: `${minWidthThreshold}px` }, { children: title }))) : (_jsx(_Fragment, {})) }, `tag-threshold-${limit !== null && limit !== void 0 ? limit : ""}-${i}-${randomIdFragment}`));
            })) : (_jsx(_Fragment, {})), yMaxTitle && yMax && (_jsx(Text, Object.assign({ nativeID: "tag-y-max" +
                    (randomIdFragment ? `-${randomIdFragment}` : ""), style: [
                    boxShadow,
                    tag,
                    tagYaxis,
                    {
                        bottom: yMax,
                        right: paddings.x,
                        transform: transformStyle,
                    },
                ] }, { children: yMaxTitle }))), yMinTitle && yMaxTitle && yMax && yMin && (_jsx(Text, Object.assign({ nativeID: "tag-y-mid" +
                    (randomIdFragment ? `-${randomIdFragment}` : ""), style: [
                    boxShadow,
                    tag,
                    tagYaxis,
                    {
                        bottom: (yMin + yMax) / 2,
                        right: paddings.x,
                        transform: transformStyle,
                    },
                ] }, { children: (Number(yMinTitle) + Number(yMaxTitle)) / 2 }))), yMinTitle && yMin && (_jsx(Text, Object.assign({ nativeID: "tag-y-min" +
                    (randomIdFragment ? `-${randomIdFragment}` : ""), style: [
                    boxShadow,
                    tag,
                    tagYaxis,
                    {
                        bottom: yMin,
                        right: paddings.x,
                        transform: transformStyle,
                    },
                ] }, { children: yMinTitle })))] })) : (_jsx(_Fragment, {}));
}
